import MediaPlayer                                 from 'hasplayer.js';
import {Observable}                                from 'rxjs';
import {filter, map, withLatestFrom}               from 'rxjs/operators';

import IErrorsPayload from '../../../Player/Interfaces/IErrorsPayload';
import ErrorType      from '../../../Shared/Constants/ErrorType';
import Playback       from '../../../State/Stores/Playback/Playback';

/*
** HAS PLAYER ERRORS
** SE LINK BELOW
*/

// tslint:disable-next-line:max-line-length
// https://github.com/Orange-OpenSource/hasplayer.js/blob/0d56868ae696003f38cdcee711fa90f59df1ffef/app/js/streaming/ErrorHandler.js#L44

const HasPlayerError = MediaPlayer.dependencies.ErrorHandler.prototype;

const mapToError = (source: any, {hasPlayed}: Playback): IErrorsPayload => {

    switch (source.data.code) {

        case HasPlayerError.CAPABILITY_ERR_MEDIASOURCE:
        case HasPlayerError.CAPABILITY_ERR_MEDIAKEYS:
            return {
                type: ErrorType.CDM_UNAVAILABLE,
                source
            };

        case HasPlayerError.DOWNLOAD_ERR_SIDX:
        case HasPlayerError.DOWNLOAD_ERR_INIT:
        case HasPlayerError.DOWNLOAD_ERR_CONTENT:
            return {
                type: hasPlayed ?
                    ErrorType.SEGMENT_REQUEST_FAILED_DURING_PLAYBACK :
                    ErrorType.SEGMENT_REQUEST_FAILED_DURING_LOAD,
                source
            };

        case HasPlayerError.DOWNLOAD_ERR_MANIFEST:
        case HasPlayerError.MANIFEST_ERR_PARSE:
        case HasPlayerError.MANIFEST_ERR_NO_STREAM:
        case HasPlayerError.MANIFEST_ERR_NO_VIDEO:
        case HasPlayerError.MANIFEST_ERR_NO_AUDIO:
        case HasPlayerError.MANIFEST_ERR_NO_TEXT:
            return {
                type: hasPlayed ?
                    ErrorType.MANIFEST_REQUEST_FAILED_DURING_PLAYBACK :
                    ErrorType.MANIFEST_REQUEST_FAILED_DURING_LOAD,
                source
            };

        case HasPlayerError.MEDIA_KEYERR:
        case HasPlayerError.MEDIA_KEYERR_UNKNOWN:
        case HasPlayerError.MEDIA_KEYERR_CLIENT:
        case HasPlayerError.MEDIA_KEYERR_SERVICE:
        case HasPlayerError.MEDIA_KEYERR_OUTPUT:
        case HasPlayerError.MEDIA_KEYERR_HARDWARECHANGE:
        case HasPlayerError.MEDIA_KEYERR_DOMAIN:
        case HasPlayerError.MEDIA_KEYERR_EXPIRED:
        case HasPlayerError.MEDIA_KEYSYSERR_ACCESS_DENIED:
        case HasPlayerError.MEDIA_KEYMESSERR_URL_LICENSER_UNKNOWN:
        case HasPlayerError.MEDIA_KEYMESSERR_NO_CHALLENGE:
        case HasPlayerError.MEDIA_KEYMESSERR_LICENSER_ERROR:
        case HasPlayerError.MEDIA_KEYMESSERR_NO_SESSION:
            return {
                type: ErrorType.LICENSE_REQUEST_FAILED,
                source
            };

        default:
            return {
                type: ErrorType.UNKNOWN_SOLUTION_ERROR,
                source
            };
    }
};

const createMediaErrorsStream = (
    hasPlayer: MediaPlayer,
    playbackStoreUpdate$: Observable<Playback>
): Observable<IErrorsPayload> =>
    Observable
        .create(observer => {
            const handler = e => observer.next(e);

            hasPlayer.addEventListener('error', handler);

            return () => hasPlayer.removeEventListener('error', handler);
        })
        .pipe(
            withLatestFrom(playbackStoreUpdate$),
            map(([err, latestPlaybackValue]) => mapToError(err, latestPlaybackValue)),
            // Ignore any errors mapped to null
            filter(Boolean)
        );

export default createMediaErrorsStream;